export default {
  comprovanteSolicitacao: state => state.comprovanteSolicitacao
};
